import { render, staticRenderFns } from "./InvoiceDocuments.vue?vue&type=template&id=72f4b656&"
import script from "./InvoiceDocuments.vue?vue&type=script&lang=js&"
export * from "./InvoiceDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports